// api.js
// const API_BASE_URL = 'http://localhost:5000/api';

const API_BASE_URL = 'https://landnest.net:7000/api';

export const normalizeLookingFor = (value) => {
  if (!value) return null;
  return value.toLowerCase();
};

export const normalizePropertyType = (value) => {
  if (!value) return null;
  return value.toLowerCase();
};

// Get filter options for auction properties
export const getAuctionFilterOptions = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/properties/auction/options/filters`);
    const data = await response.json();
    console.log('Auction filter options response:', data);
    if (!response.ok) throw new Error(data.error || 'Failed to fetch');
    return data;
  } catch (error) {
    console.error('API Error:', error);
    return { 
      success: false, 
      typeOptions: [],
      bankOptions: [],
      priceRange: { min: 0, max: 1000000000 },
      totalProperties: 0
    };
  }
};

// Get map properties for auction
export const getAuctionMapProperties = async (filters) => {
  const params = new URLSearchParams();

  console.log('Auction API Request Filters:', filters);

  if (filters.type && filters.type.length > 0) {
    const typeValue = Array.isArray(filters.type) 
      ? filters.type.map(t => normalizePropertyType(t)).filter(Boolean).join(',')
      : normalizePropertyType(filters.type);
    if (typeValue) params.append("type", typeValue);
  }
  
  if (filters.bankName && filters.bankName.length > 0) {
    const bankValue = Array.isArray(filters.bankName) 
      ? filters.bankName.join(',')
      : filters.bankName;
    if (bankValue) params.append("bank_name", bankValue);
  }

  if (filters.bounds) {
    params.append('south', filters.bounds.south);
    params.append('north', filters.bounds.north);
    params.append('west', filters.bounds.west);
    params.append('east', filters.bounds.east);
  }
  
  if (filters.zoom) params.append('zoom', filters.zoom);
  if (filters.priceMin != null) params.append('priceMin', filters.priceMin);
  if (filters.priceMax != null) params.append('priceMax', filters.priceMax);
  if (filters.limit) params.append('limit', filters.limit);

  try {
    const response = await fetch(`${API_BASE_URL}/properties/auctionpropertymap?${params.toString()}`);
    const data = await response.json();
    console.log('Auction map properties response:', data);
    if (!response.ok) throw new Error(data.error || "Failed to fetch");
    return data;
  } catch (error) {
    console.error("API Error:", error);
    return { success: false, properties: [], count: 0 };
  }
};

// Get single auction property by ID
export const getAuctionPropertyById = async (id) => {
  try {
    const response = await fetch(`${API_BASE_URL}/properties/auction/property/${id}`);
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Failed to fetch');
    return data;
  } catch (error) {
    console.error('API Error:', error);
    return { success: false, property: null };
  }
};